module.exports = __webpack_public_path__ + "img/Create Subpackage.5db24183.png";